import {combineReducers} from 'redux'
import {userReducer} from './user/userSlice'
import {bidReducer} from './bid/bidSlice'
import {endpointReducer} from './endpoint/endpoingSlice'
import {appReducer} from './app/appSlice'
import {carReducer} from './car/carSlice'
import {requisiteReducer} from './requisite/requisiteSlice'
import {sellerReducer} from './seller/sellerSlice'
import {bidApi} from './bid/bidApi'
import {sellerApi} from './seller/sellerApi'
import {userApi} from './user/userApi'
import {registersReducer} from './registers/registersSlice'
import {notificationsReducer} from './notifications/notificationsSlice'
import {employeesReducer} from './employees/employeesSlice'
import {transportsReducer} from './transports/transportsSlice'
import {transportsApi} from './transports/transportsApi'
import {docTemplatesApi} from './doc-templates/docTemplatesApi'
import {notificationsApi} from './notifications/notificationsApi'
import {endpointApi} from './endpoint/endpointApi'

const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  transports: transportsReducer,
  [userApi.reducerPath]: userApi.reducer,
  bid: bidReducer,
  [bidApi.reducerPath]: bidApi.reducer,
  car: carReducer,
  endpoint: endpointReducer,
  requisite: requisiteReducer,
  seller: sellerReducer,
  registers: registersReducer,
  notifications: notificationsReducer,
  employees: employeesReducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [docTemplatesApi.reducerPath]: docTemplatesApi.reducer,
  [sellerApi.reducerPath]: sellerApi.reducer,
  [transportsApi.reducerPath]: transportsApi.reducer,
  [endpointApi.reducerPath]: endpointApi.reducer,
});

export {rootReducer};
